
import { ref, onMounted, watch, Ref } from "vue";
import { defineComponent } from "vue";
import Api from "../../services/Api";
import useAlert from "../../composables/Alert";
import Button from "@/components/Button.vue"
import { Modal } from "bootstrap";
import ModalPlanilhaVeiculo from "./components/ModalPlanilhaVeiculo.vue";
import ModalDownloadPlanilhaVeiculo from "./components/ModalDownloadPlanilhaVeiculo.vue";
import moment from "moment";
import axios from "axios";
import {  useLoaderStore } from "@/store/LoaderStore";


export default defineComponent({
  name: "UploadPlanilhasVeiculo",
  components: {
    Button,
    ModalPlanilhaVeiculo,
    ModalDownloadPlanilhaVeiculo,
  },

  setup() {

    const { showTimeAlert } = useAlert();
    const buttonText = ref('Enviar planilha');
    const botaoDesabilitado = ref(false);
    const arquivo: Ref<any> = ref();
    const marca: Ref<string | null> = ref(null);
    const fileInput: Ref<any> = ref(null);
    const marcas: Ref<any> = ref([]);
    const historicoArquivos: Ref<any> = ref([]);
    const qtdArquivosSalvos: Ref<number> = ref(0)
    const file: Ref<any> = ref(null);
    const loadingUpload: Ref<boolean> = ref(false);
    const rodandoFila = ref(false)
    const alteraRodandoFila = (valor: boolean) => rodandoFila.value = valor;
    const loaderStore = useLoaderStore();
    const arquivoSelecionado: Ref<any> = ref("")
    const modalPlanilhaFiltro: Ref<any> = ref()
    const modalDownloadPlanilhaFiltro: Ref<any> = ref()
    const modalConfirmaAcao: Ref<any> = ref()
    const loaderLista: Ref<boolean> = ref(false);

    const openInput = () => fileInput.value.click();

    const uploadFile = async (event: any) => {
      const file = event.target.files[0]
      arquivo.value = file
    };

    async function getToken() {
      return localStorage.getItem('token_usuario');
    };

    function dropHandler(e) {

      stopDefault(e)

      if (e.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        [...e.dataTransfer.items].forEach((item) => {
          // If dropped items aren't files, reject them
          if (item.kind === "file") {
            file.value = item.getAsFile();
          }
        });
      } else {
        // Use DataTransfer interface to access the file(s)
        [...e.dataTransfer.files].forEach((fileParam) => {
          file.value = fileParam;
        });
      }

      arquivo.value = file.value
    }

    function stopDefault(e) {
      // Prevent default behavior (Prevent file from being opened)
      e.stopPropagation();
      e.preventDefault();
    }

    function formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    function limparArquivo() {
      arquivo.value = null
    }

    function formatDate(isoString) {
      const date = new Date(isoString);
      const day   = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year  = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    async function enviarPlanilha(){
      if(!arquivo.value) return
      loadingUpload.value = true
      botaoDesabilitado.value = true
      try{
        const timeStamp = (new Date()).getTime();

        const formData = new FormData()
        formData.append('arquivo', arquivo.value);
        formData.append('nome', `${timeStamp}-${arquivo.value.name}`);
        formData.append('pasta', 'planilhas/veiculo');

        // Não definir manualmente Content-Type para FormData: o navegador define o boundary corretamente
        const response =  await axios.post("processaPlanilhaVeiculos", formData, {
          headers: {
            'Authorization': `Bearer ${await getToken()}`
          }
        });

        const { data , message, error } = response.data

        if(error){
          // Exibir mensagem retornada pelo servidor quando disponível
          showTimeAlert(message || 'Erro ao enviar planilha', 'error')
          console.log('Error ao enviar planilha', message)
          loaderStore.close()
          return
        }

        // Sucesso: atualizar lista e fechar modal
        showTimeAlert('Planilha enviada com sucesso', 'success')
        pegarListaDePlanilhas()
        fechaModalConfirmaAcao()
      }catch(err: any){
        // Tratar 422 (validação) explicitamente lendo o corpo da resposta
        const status = err?.response?.status
        const respData = err?.response?.data
        if(status === 422){
          const errorMessage = respData?.errors[0]['errors']
          //console.log(errorMessage[0]['errors']);
          
          showTimeAlert(errorMessage, 'error')
        } else {
          showTimeAlert('Erro ao enviar planilha', 'error')
        }
        console.error('Erro ao enviar planilha', err)
      }finally{
        loadingUpload.value = false
        botaoDesabilitado.value = false
      }
    }

    async function pegarListaDePlanilhas() {
    loaderLista.value = true
    try{
      const result = await Api.get("retornaListaDeArquivos", { filePath: 'planilhas/veiculo/', queueName: 'tabela_veiculos' })

      if(!result.lista || result.lista.length === 0) {
        loaderLista.value = false
        return showTimeAlert("Nenhum arquivo encontrado")
      } 

      const lista = result.lista
      //ordernar por data
      lista.sort((a, b) => new Date(b.data).getTime() - new Date(a.data).getTime())

      qtdArquivosSalvos.value = lista.length;
      historicoArquivos.value = lista.slice(0, 10);
      }catch(error){
      console.log('Erro ao pegar lista de planilhas', error)
      showTimeAlert("Erro ao pegar lista de planilhas", "error")
    }finally{
      loaderLista.value = false
    }
  }

  function formatData(data) {
    const dataFormatada = moment(data).format('DD/MM/YYYY');
    return dataFormatada;
  }

    ///////////////////// MODAL PRODUTO LOG /////////////////////

    function abreModal(arquivo?: any) {
      arquivoSelecionado.value = arquivo || {}
      modalPlanilhaFiltro.value.show()
    }

    async function fechaModal() {
      arquivoSelecionado.value = ""
      modalPlanilhaFiltro.value.hide()
    }


    function abreModalConfirmaAcao() {
      modalConfirmaAcao.value.show()
    }

    function fechaModalConfirmaAcao() {
      modalConfirmaAcao.value.hide()
    }

    ///////////////////// MODAL PRODUTO LOG /////////////////////

    //////////////// MODAL DOWNLOAD PLANILHA ////////////////////

    function abreModalDownload(arquivo?: any) {
      arquivoSelecionado.value = arquivo || {}
      modalDownloadPlanilhaFiltro.value.show()
    }

    function fechaModalDownload() {
      arquivoSelecionado.value = ""
      modalDownloadPlanilhaFiltro.value.hide()
    }

    //////////////// MODAL DOWNLOAD PLANILHA ////////////////////
    

    watch(() => rodandoFila.value, async () => { pegarListaDePlanilhas() }, { deep: true })

    onMounted(async() => {

      modalPlanilhaFiltro.value = new Modal(document.querySelector(`#ModalPlanilhaVeiculos`));

      modalDownloadPlanilhaFiltro.value = new Modal(document.querySelector(`#ModalDownloadPlanilhaVeiculos`));

      modalConfirmaAcao.value = new Modal(document.querySelector(`#modalConfirmaAcao`));

      pegarListaDePlanilhas()

    })

    return {

      dropHandler,
      stopDefault,
      arquivo,
      limparArquivo,
      buttonText,
      botaoDesabilitado,
      enviarPlanilha,
      marcas,
      marca,
      historicoArquivos,
      formatBytes,
      openInput,
      uploadFile,
      fileInput,
      formatData,
      history,
      qtdArquivosSalvos,
      abreModal,
      fechaModal,
      arquivoSelecionado,
      rodandoFila,
      alteraRodandoFila,
      abreModalDownload,
      fechaModalDownload,
      loadingUpload,
      formatDate,
      abreModalConfirmaAcao,
      loaderLista
    }
  },
});
